import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { isExternalUrl } from "~/utils/url";

// Props

export default /*@__PURE__*/_defineComponent({
  __name: 'SanityLink',
  props: {
  href: {
    type: String,
    required: true,
  },
},
  setup(__props) {

const props = __props;

const isExternalLink = computed(() => isExternalUrl(props.href));

// Extract domain from URL
const getDomain = (url: string) => {
  try {
    return new URL(url).hostname;
  } catch (error) {
    return url;
  }
};

// Get the domain of the current link
const linkDomain = computed(() => {
  if (isExternalLink.value) {
    return getDomain(props.href);
  }
  return null;
});

// Only show tooltip after hydration to prevent SSR/client mismatches
const showTooltip = ref(false);

onMounted(() => {
  // Use nextTick to ensure this runs after hydration
  nextTick(() => {
    showTooltip.value = true;
  });
});

return (_ctx: any,_cache: any) => {
  const _component_NuxtLink = _resolveComponent("NuxtLink")!
  const _component_UTooltip = _resolveComponent("UTooltip")!

  return (_unref(isExternalLink) && _unref(showTooltip))
    ? (_openBlock(), _createBlock(_component_UTooltip, {
        key: 0,
        text: _unref(linkDomain),
        popper: { placement: 'top', arrow: true }
      }, {
        default: _withCtx(() => [
          _createVNode(_component_NuxtLink, {
            href: __props.href,
            target: _unref(isExternalLink) ? '_blank' : undefined,
            external: _unref(isExternalLink),
            class: "text-primary-500"
          }, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "default")
            ]),
            _: 3
          }, 8, ["href", "target", "external"])
        ]),
        _: 3
      }, 8, ["text"]))
    : (_openBlock(), _createBlock(_component_NuxtLink, {
        key: 1,
        href: __props.href,
        target: _unref(isExternalLink) ? '_blank' : undefined,
        external: _unref(isExternalLink),
        class: "text-primary-500"
      }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["href", "target", "external"]))
}
}

})